export const siteData = {
  brand: "Walker Ottawa",
  eventName: "Built to Lead",
  tagline: "Inspiring the next generation of leaders through real stories, resilience, and vision.",
  description: "A live leadership experience designed for teenagers and their guardians, delivered by three of Ottawa's most respected women in sport, media, and public service.",
  date: "April 19th",
  time: "1:00 PM to 4:00 PM",
  location: "Shenkman Arts Centre",
  attendees: "500+",
  audienceAge: "13 to 18",
};

export const navLinks = [
  { label: "About", href: "#about" },
  { label: "Speakers", href: "#speakers" },
  { label: "Experience", href: "#experience" },
  { label: "Schedule", href: "#schedule" },
  { label: "Sponsors", href: "#sponsors" },
];

export const whyContent = {
  title: "Why Built to Lead Exists",
  paragraphs: [
    "Teenagers today are facing uncertainty around identity, confidence, and direction. Parents and guardians are searching for meaningful experiences that help spark ambition and purpose.",
    "Built to Lead brings families together in one room to hear authentic stories of perseverance, leadership, and success from role models who live and work in our city.",
  ],
};

export const audienceStats = [
  { label: "Total Attendees", value: "500+", sublabel: "A community gathering of teen girls and supportive families." },
  { label: "Teen Girls", value: "Ages 12-18", sublabel: "Young women attending to hear real stories of leadership, resilience, and success." },
  { label: "Parents & Guardians", value: "250+", sublabel: "Families supporting the next generation of confident young leaders." },
];

export const experienceFeatures = [
  { title: "Three keynote stories", description: "Powerful personal narratives from accomplished leaders" },
  { title: "Live moderated discussion", description: "Dynamic panel interviews hosted by Rosey Edeh" },
  { title: "Audience Q and A", description: "Direct engagement with speakers" },
  { title: "Networking intermission", description: "Connect with like-minded families and community leaders" },
  { title: "Interactive sponsor activations", description: "Hands-on experiences at themed kiosks" },
  { title: "VIP meet and greet", description: "Exclusive access to speakers for premium attendees" },
];

export const speakers = [
  {
    name: "Brianne Jenner",
    role: "4-Time Olympian & Professional Hockey Player",
    description: "Known for discipline, resilience, and excellence under pressure.",
    initial: "BJ",
    image: "/Brianne_jenner.png",
    activation: "A Brianne Jenner display featuring medals, memorabilia, and photo opportunities",
  },
  {
    name: "Patricia Boal",
    role: "Chief News Anchor, CTV Ottawa",
    description: "Representing professionalism, communication, and leadership in media.",
    initial: "PB",
    image: "/patricia_boal.webp",
    activation: "A CTV News style desk with Patricia Boal",
  },
  {
    name: "Trish Ferguson",
    role: "Senior Leader, Ottawa Police Service",
    description: "Speaking to service, accountability, and community leadership.",
    initial: "TF",
    image: "/DC-Ferguson.jpg",
    activation: "An interactive police engagement kiosk with Trish Ferguson",
  },
];

export const moderator = {
  name: "Rosey Edeh",
  role: "Television Personality & Three-Time Olympian",
  description: "Rosey Edeh is a Canadian television personality, respected news anchor, and three-time Olympian. She brings authenticity, energy, and world-class presence to the stage as she guides the event and connects with our audience.",
  initial: "RE",
  image: "/rosey-edeh.avif",
};

export const programFlow = [
  { time: "12:30 PM", title: "Doors Open" },
  { time: "1:00 PM", title: "Opening / Rosey Edeh" },
  { time: "1:15 PM", title: "Panel Introduction" },
  { time: "1:30 PM", title: "Individual Keynote Stories" },
  { time: "2:15 PM", title: "Activation Break" },
  { time: "2:45 PM", title: "Panel Discussion" },
  { time: "3:15 PM", title: "Audience Q&A" },
  { time: "3:45 PM", title: "Closing Affirmations" },
];

export const sponsorReasons = [
  "Direct exposure to 500 local families",
  "Association with leadership, youth development, and community impact",
  "On-site engagement rather than passive impressions",
  "Content and media opportunities post event",
];

export const legacyItems = [
  "Expanded school involvement",
  "Scholarship and mentorship opportunities",
  "Growing sponsor partnerships",
  "Career opportunities",
  "A recognized leadership platform in Ottawa",
];

export const images = {
  hero: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=1920&q=80",
  speaking: "https://images.unsplash.com/photo-1762158007969-eb58e74ee3d3?w=1200&q=80",
  networking: "https://images.unsplash.com/photo-1515169067868-5387ec356754?w=1200&q=80",
  youth: "https://images.unsplash.com/photo-1531545514256-b1400bc00f31?w=1200&q=80",
};
